<ng-container *transloco="let t">
    <mat-card
        class="altair-card endpoints-card bg-white border-radius border-none d-block"
        [class.component-dark-theme]="themeService.isDark()"
    >
        <mat-card-content>
            <h5 class="mt-0 font-16">{{ t("endpoints-discovered") }}&nbsp;<i class="ri-information-2-fill" matTooltip="{{ t('total-endpoints-discovered') }}"></i></h5>
            <h2 class="text-primary my-3 text-center">
                <span>{{ (countUp == 0 ? countUp : count) | number }}</span>
            </h2>
            <br>
            <p class="mb-0"><span class="badge text-soft-success">{{ t("alive-endpoints") }}: {{ aliveCount | number }}</span></p>
        </mat-card-content>
    </mat-card>
</ng-container>
